
// Library imports.
import axios, { AxiosResponse } from "axios";
import axiosInstance from '../axiosInstance';

// App imports.
import { config } from "../config";
import { baseWorker } from "../baseWorker";
import { Assessment1FuelTypesStatusHolder } from "./state";
import { Assessment1FuelTypeInfo } from "./state";
import { Assessment2aModel } from "./state";
import { Assessment2bFuelTypesStatusHolder } from "./state";
import { Assessment2bFuelTypeInfo } from "./state";
import { Assessment3aFuelTypesStatusHolder } from "./state";
import { Assessment3aFuelTypeInfo } from "./state";
import { Assessment3bFuelTypesStatusHolder } from "./state";
import { Assessment3bFuelTypeInfo } from "./state";
import { Assessment4Model } from "./state";
import { OverallAssessmentFuelTypesStatusHolder } from "./state";

// Define interface to describe a contact.  Note that we'll only have an _id field when retrieving or adding, so
// it has to be optional.
export interface ISavedAssessmentInfo {
  assessmentId: number
  ,assessmentId2: string
  , dateCreated: Date
  , fiscalYear: number
  , granteeName: string
  , granteeId: number
  , assessmentType: number
  , userId: number
  , userName: string
}

export class Worker extends baseWorker {

  //method to get Saved Assessments.  Returns an array of objects compatible with ISavedAssessmentInfo interface
  public async listSavedAssessments(): Promise<ISavedAssessmentInfo[]> {

    
    const savedAssessmentsReturned: ISavedAssessmentInfo[] = [];
    try {
      const response: AxiosResponse = 
                          await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessments`);   
      response.data.forEach(function (assessmentDatabaseRow) {
        const savedAssessment: ISavedAssessmentInfo = {
          assessmentId: assessmentDatabaseRow.DREB_ID,
          assessmentId2: assessmentDatabaseRow.DREB_ID2,
          dateCreated: assessmentDatabaseRow.ASSESSMENT_DATE,
          fiscalYear: assessmentDatabaseRow.FISCAL_YEAR,
          granteeName: assessmentDatabaseRow.GRANTEE_NAME,
          granteeId: assessmentDatabaseRow.GRAN_ID,
          assessmentType: assessmentDatabaseRow.ASSESSMENT_TYPE,
          userId: assessmentDatabaseRow.USER_ID,
          userName: assessmentDatabaseRow.USER_USERNAME,
        };
        savedAssessmentsReturned.push(savedAssessment);
      });
    }
    catch (error) {
      return this.handleError(error);
    }

    return savedAssessmentsReturned;
  }

  public async deleteSavedAssessment(inID, inID2): Promise<void> {

    //pass parameter in FormData object because Php expects form encoded POST
    try {
      //TODO: change this to delete method when implementing REST
      await axiosInstance.delete(`${config.apiBaseURL}/electricbaseload/assessment/${inID}/${inID2}`);   
    }
    catch (error) {
      return this.handleError(error);
    };
  }

  public async addAssessment(granteeId, fiscalYear, assessmentType): Promise<number> {

    //pass parameter in FormData object because Php expects form encoded POST
    const formData = new FormData();
    formData.append('assessmentType', assessmentType);
    formData.append('granteeId', granteeId);
    formData.append('fiscalYear', fiscalYear);

    let assessmentKey: number = -1;
    try {
      const response: AxiosResponse = await axiosInstance.post(`${config.apiBaseURL}/electricbaseload/assessment`, formData);   
      assessmentKey = Number(response.data[0]["DREB_ID"]);
    }
    catch (error) {
      return this.handleError(error);
    };
    return assessmentKey;
  }

  public async updateAssessmentDetails(assessmentId
    , assessmentType
    , fieldsToUpdate
  ): Promise<string> {

    //pass parameter in FormData object because Php expects form encoded POST
    const formData = new FormData();
    formData.append('assessmentId', assessmentId);
    formData.append('assessmentType', assessmentType);
    formData.append('fieldsToUpdate', JSON.stringify(fieldsToUpdate));

    let response: AxiosResponse = null;
    try {
      response = await axiosInstance.post(`${config.apiBaseURL}/electricbaseload/assessment/type/${assessmentType}/${assessmentId}`, formData);         
    }
    catch (error) {
      return this.handleError(error);
    };
    return 'TRUE';
  }
  public async getAssessment1Details(assessmentId): Promise<Assessment1FuelTypesStatusHolder> {
    
    
    let response: AxiosResponse = null;
    try {
      
      response =
        //using the apiBaseURL property defined in config.ts which we import above
        await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/1/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };

    const row = response.data[0];
    let holder = new Assessment1FuelTypesStatusHolder();
    holder.FiscalYear = Number(response.data["Year"]);
    holder.Grantee = Number(response.data["GranteeId"]);

    holder.NaturalGas = this.populateFuelType(response.data["FuelTypes"]["NaturalGas"]
      , holder.NaturalGas);
    holder.FuelOil = this.populateFuelType(response.data["FuelTypes"]["FuelOil"]
      , holder.FuelOil);
    holder.Propane = this.populateFuelType(response.data["FuelTypes"]["Propane"]
      , holder.Propane);

    //console.log("holder:", holder);
    return holder;
  }

  public async getAssessment2aDetails(assessmentId): Promise<Assessment2aModel> {
    //pass parameter in FormData object because Php expects form encoded POST
    
    let response: AxiosResponse = null;
    try {
      response =
        await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/2a/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };

    const row = response.data[0];
    let model = new Assessment2aModel();
    model.FiscalYear = Number(response.data["Year"]);
    model.Grantee = Number(response.data["GranteeId"]);
    const self = this;
    //iterate the values returned in returnedFuelTypeArray
    //and populate corresponding property in fuelType
    Object.keys(response.data).forEach(function (key, index) {
      if (key.indexOf("Num") > -1) {
        model[key] = self.nullOrNumberToNumber(response.data[key]);
      }
      else if (key == "viewAnywayFlag") {
        model[key] = self.flagToNullOrBoolean(response.data[key]);
      }
      else {
        model[key] = response.data[key];
      }
    }, response.data);

    //console.log("holder:", holder);
    return model;
  }
  public async getAssessment2bDetails(assessmentId): Promise<Assessment2bFuelTypesStatusHolder> {
    let response: AxiosResponse = null;
    try {
      response =
        await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/2b/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };
    let holder = new Assessment2bFuelTypesStatusHolder();
    holder.FiscalYear = Number(response.data["Year"]);
    holder.Grantee = Number(response.data["GranteeId"]);
    holder.Electric = this.populateFuelType(response.data["FuelTypes"]["Electric"]
      , holder.Electric);
    holder.NaturalGas = this.populateFuelType(response.data["FuelTypes"]["NaturalGas"]
      , holder.NaturalGas);
    holder.FuelOil = this.populateFuelType(response.data["FuelTypes"]["FuelOil"]
      , holder.FuelOil);
    holder.Propane = this.populateFuelType(response.data["FuelTypes"]["Propane"]
      , holder.Propane);
    return holder;
  }

  public async getAssessment3aDetails(assessmentId): Promise<Assessment3aFuelTypesStatusHolder> {
    
    let response: AxiosResponse = null;
    try {
      response =
      await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/3a/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };

    let holder = new Assessment3aFuelTypesStatusHolder();
    holder.FiscalYear = Number(response.data["Year"]);
    holder.Grantee = Number(response.data["GranteeId"]);
    holder.Electric = this.populateFuelType(response.data["FuelTypes"]["Electric"]
      , holder.Electric);
    holder.NaturalGas = this.populateFuelType(response.data["FuelTypes"]["NaturalGas"]
      , holder.NaturalGas);
    holder.FuelOil = this.populateFuelType(response.data["FuelTypes"]["FuelOil"]
      , holder.FuelOil);
    holder.Propane = this.populateFuelType(response.data["FuelTypes"]["Propane"]
      , holder.Propane);
    return holder;
  }

  public async getAssessment3bDetails(assessmentId): Promise<Assessment3bFuelTypesStatusHolder> {
    let response: AxiosResponse = null;
    try {
      response =
        await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/3b/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };

    let holder = new Assessment3bFuelTypesStatusHolder();
    holder.FiscalYear = Number(response.data["Year"]);
    holder.Grantee = Number(response.data["GranteeId"]);
    holder.NaturalGas = this.populateFuelType(response.data["FuelTypes"]["NaturalGas"]
      , holder.NaturalGas);
    holder.FuelOil = this.populateFuelType(response.data["FuelTypes"]["FuelOil"]
      , holder.FuelOil);
    holder.Propane = this.populateFuelType(response.data["FuelTypes"]["Propane"]
      , holder.Propane);
    return holder;
  }

  private populateFuelType(returnedFuelTypeArray, fuelType) {
    const self = this;
    //iterate the values returned in returnedFuelTypeArray
    //and populate corresponding property in fuelType
    Object.keys(returnedFuelTypeArray).forEach(function (key, index) {
      if (key == "numHouseholds") {
        fuelType[key] = self.nullOrNumberToNumber(returnedFuelTypeArray[key]);
      }
      else if (key == "viewAnyway" || key == "viewAnywayFlag") {
        fuelType[key] = self.flagToNullOrBoolean(returnedFuelTypeArray[key]);
      }
      else if (key.indexOf("Desc") > -1) {
        fuelType[key] = returnedFuelTypeArray[key];
      }
      else if (key.indexOf("Expenditure") > -1) {
        fuelType[key] = self.nullOrNumberToNumber(returnedFuelTypeArray[key]);
      }
      else if (key.indexOf("Num") > -1) {
        fuelType[key] = self.nullOrNumberToNumber(returnedFuelTypeArray[key]);
      }
      else {
        fuelType[key] = returnedFuelTypeArray[key];
      }
    }, returnedFuelTypeArray);

    return fuelType;
  }

  public async getAssessment4Details(assessmentId): Promise<Assessment4Model> {
    
    let response: AxiosResponse = null;
    try {
      response =
      await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/4/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };
    let model = new Assessment4Model();
    model.FiscalYear = Number(response.data["Year"]);
    model.Grantee = Number(response.data["GranteeId"]);
    const self = this;
    //iterate the values returned in returnedFuelTypeArray
    //and populate corresponding property in fuelType
    Object.keys(response.data).forEach(function (key, index) {
      if (key.indexOf("Num") > -1) {
        model[key] = self.nullOrNumberToNumber(response.data[key]);
      }
      else if (key == "viewAnywayFlag") {
        model[key] = self.flagToNullOrBoolean(response.data[key]);
      }
      else {
        model[key] = response.data[key];
      }
    }, response.data);
    return model;
  }
  

  public async getOverallAssessmentDetails(assessmentId): Promise<OverallAssessmentFuelTypesStatusHolder> {
    let response: AxiosResponse = null;
    try {
      response =
      await axiosInstance.get(`${config.apiBaseURL}/electricbaseload/assessment/type/oa/${assessmentId}`);
    }
    catch (error) {
      return this.handleError(error);
    };
    
    const row = response.data[0];
    let model = new OverallAssessmentFuelTypesStatusHolder();
    model.FiscalYear = Number(response.data["Year"]);
    model.Grantee = Number(response.data["GranteeId"]);
    const self = this;
    //iterate the values returned in returnedFuelTypeArray
    //and populate corresponding property in fuelType
    Object.keys(response.data).forEach(function (key, index) {
      if (key.indexOf("Num") > -1) {
        model[key] = self.nullOrNumberToNumber(response.data[key]);
      }
      else if (key == "viewAnywayFlag") {
        model[key] = self.flagToNullOrBoolean(response.data[key]);
      }
      else {
        model[key] = response.data[key];
      }
    }, response.data);
    model.Electric = this.populateFuelType(response.data["FuelTypes"]["Electric"]
      , model.Electric);
    model.NaturalGas = this.populateFuelType(response.data["FuelTypes"]["NaturalGas"]
      , model.NaturalGas);
    model.FuelOil = this.populateFuelType(response.data["FuelTypes"]["FuelOil"]
      , model.FuelOil);
    model.Propane = this.populateFuelType(response.data["FuelTypes"]["Propane"]
      , model.Propane);

    return model;
  }
  
}
